import React from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';
import './AdminProfessionalInfo.css';

function AdminElevatorTechnicianFields({ formData, updateField }) {
    // Helper function for single-select fields to allow unselecting
    const toggleSingleField = (field, value) => {
        const newValue = formData[field] === value ? null : value;
        updateField(field, newValue);
    };

    // Helper functions for multi-select fields
    const toggleArrayField = (field, item) => {
        const currentArray = formData[field] || [];
        // Ensure we ARE working with an array (in case of type mismatch)
        const safeArray = Array.isArray(currentArray) ? currentArray : [currentArray];

        const updated = safeArray.includes(item)
            ? safeArray.filter(i => i !== item)
            : [...safeArray, item];
        updateField(field, updated);
    };

    // Field options
    const fieldExperiences = [
        "Installation", "Maintenance", "Troubleshooting",
        "Modernization", "Testing & Commissioning"
    ];

    const systemKnowledgeList = [
        "Traction Elevators", "Hydraulic Elevators",
        "MRL Elevators", "Freight Elevators", "Escalators"
    ];

    const controlSystems = [
        "VVVF Drives", "PLC", "Relay Logic"
    ];

    const brands = [
        "Otis", "KONE", "Schindler", "Thyssenkrupp",
        "Mitsubishi", "Fujitec", "Hitachi", "Hyundai"
    ];

    return (
        <>
            <div className="mb-5">
                <h4 className="mb-3" style={{ color: "black" }}>Elevator / Escalator Expertise</h4>

                <h6 className="mb-3" style={{ color: "black", fontWeight: 'bold' }}>Field Experience:</h6>
                <Row className="g-3 mb-4">
                    {fieldExperiences.map((exp, idx) => (
                        <Col xs={6} md={4} key={idx}>
                            <Button
                                variant="light"
                                className={`language-btn jobtype-btn w-100 ${formData.elevator_field_experience?.includes(exp) ? 'selected-button' : ''}`}
                                onClick={() => toggleArrayField('elevator_field_experience', exp)}
                            >
                                {exp}
                            </Button>
                        </Col>
                    ))}
                </Row>

                <h6 className="mb-3" style={{ color: "black", fontWeight: 'bold' }}>System Knowledge:</h6>
                <Row className="g-3 mb-4">
                    {systemKnowledgeList.map((sys, idx) => (
                        <Col xs={6} md={4} key={idx}>
                            <Button
                                variant="light"
                                className={`language-btn jobtype-btn w-100 ${formData.elevator_system_knowledge?.includes(sys) ? 'selected-button' : ''}`}
                                onClick={() => toggleArrayField('elevator_system_knowledge', sys)}
                            >
                                {sys}
                            </Button>
                        </Col>
                    ))}
                </Row>

                <h6 className="mb-3" style={{ color: "black", fontWeight: 'bold' }}>Control System Experience:</h6>
                <Row className="g-3 mb-4">
                    {controlSystems.map((sys, idx) => (
                        <Col xs={6} md={4} key={idx}>
                            <Button
                                variant="light"
                                className={`language-btn jobtype-btn w-100 ${formData.elevator_control_experience?.includes(sys) ? 'selected-button' : ''}`}
                                onClick={() => toggleArrayField('elevator_control_experience', sys)}
                            >
                                {sys}
                            </Button>
                        </Col>
                    ))}
                </Row>

                <h6 className="mb-3" style={{ color: "black", fontWeight: 'bold' }}>Brand Experience:</h6>
                <Row className="g-3 mb-4">
                    {brands.map((brand, idx) => (
                        <Col xs={6} md={3} key={idx}>
                            <Button
                                variant="light"
                                className={`language-btn jobtype-btn w-100 ${formData.elevator_brand_experience?.includes(brand) ? 'selected-button' : ''}`}
                                onClick={() => toggleArrayField('elevator_brand_experience', brand)}
                            >
                                {brand}
                            </Button>
                        </Col>
                    ))}
                </Row>
            </div>

            <div className="mb-5">
                <h4 className="mb-3" style={{ color: "black" }}>Certification & Training</h4>

                <Row className="g-4">
                    <Col md={12}>
                        <h6 className="mb-3" style={{ color: "black", fontWeight: 'bold' }}>Technical Diploma / ITI:</h6>
                        <div className="d-flex gap-3">
                            <Button
                                variant="light"
                                className={`language-btn jobtype-btn flex-grow-1 ${formData.elevator_technical_diploma === 'Yes' ? 'selected-button' : ''}`}
                                onClick={() => toggleSingleField('elevator_technical_diploma', 'Yes')}
                            >
                                Yes
                            </Button>
                            <Button
                                variant="light"
                                className={`language-btn jobtype-btn flex-grow-1 ${formData.elevator_technical_diploma === 'No' ? 'selected-button' : ''}`}
                                onClick={() => toggleSingleField('elevator_technical_diploma', 'No')}
                            >
                                No
                            </Button>
                        </div>
                    </Col>

                    <Col md={12}>
                        <h6 className="mb-3" style={{ color: "black", fontWeight: 'bold' }}>Safety Training:</h6>
                        <div className="d-flex gap-3">
                            <Button
                                variant="light"
                                className={`language-btn jobtype-btn flex-grow-1 ${formData.elevator_safety_training === 'Yes' ? 'selected-button' : ''}`}
                                onClick={() => toggleSingleField('elevator_safety_training', 'Yes')}
                            >
                                Yes
                            </Button>
                            <Button
                                variant="light"
                                className={`language-btn jobtype-btn flex-grow-1 ${formData.elevator_safety_training === 'No' ? 'selected-button' : ''}`}
                                onClick={() => toggleSingleField('elevator_safety_training', 'No')}
                            >
                                No
                            </Button>
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    );
}

export default AdminElevatorTechnicianFields;
